// extracted by mini-css-extract-plugin
module.exports = {"productCardHeader":"styles_productCardHeader__1cuNU"};